/** Builds a static asset URL against the configured CDN/S3 base when present. */
export function assetUrl(path: string): string {
  const value = (path ?? '').trim();

  if (!value) {
    return '';
  }

  if (/^(?:[a-z]+:)?\/\//i.test(value) || value.startsWith('data:')) {
    return value;
  }

  const normalizedPath = value.startsWith('/') ? value : `/${value}`;
  const base = import.meta.env.VITE_ASSET_BASE_URL?.replace(/\/$/, '') ?? '';

  if (base) {
    return `${base}${normalizedPath}`;
  }

  return normalizedPath;
}
